import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ExternalLink } from 'lucide-react';

export const MovingFromSpain = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-yellow-50 to-orange-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="border-none shadow-2xl overflow-hidden">
          <div className="bg-gradient-to-r from-yellow-400 to-orange-400 p-1">
            <div className="bg-white p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="inline-block px-6 py-2 bg-yellow-100 rounded-full mb-4">
                  <span className="text-2xl mr-2">🇪🇸</span>
                  <span className="font-bold text-yellow-900">Moving from Spain?</span>
                </div>
                
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                  Transport & Relocation Services
                </h2>
                
                <div className="max-w-2xl mx-auto">
                  <p className="text-xl text-gray-700 mb-6">
                    Professional removal services are provided by
                  </p>
                  
                  <div className="bg-blue-900 text-white py-4 px-8 rounded-lg inline-block mb-6">
                    <h3 className="text-2xl md:text-3xl font-bold">
                      Sunshine Storage and Transport
                    </h3>
                  </div>
                  
                  <p className="text-lg text-gray-600 mb-8">
                    Specialists in Spain to UK removals with over 15 years of experience. We handle your TOR1 application <strong>AND</strong> transport your belongings safely home.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <CardContent className="text-center p-6 bg-blue-50 rounded-lg">
                  <div className="text-3xl mb-3">📦</div>
                  <h4 className="font-bold text-gray-900 mb-2">Full Packing Service</h4>
                  <p className="text-gray-600 text-sm">Professional packing for safe transport</p>
                </CardContent>
                
                <CardContent className="text-center p-6 bg-blue-50 rounded-lg">
                  <div className="text-3xl mb-3">🚚</div>
                  <h4 className="font-bold text-gray-900 mb-2">Direct Routes</h4>
                  <p className="text-gray-600 text-sm">Regular Spain-UK delivery schedules</p>
                </CardContent>
                
                <CardContent className="text-center p-6 bg-blue-50 rounded-lg">
                  <div className="text-3xl mb-3">✅</div>
                  <h4 className="font-bold text-gray-900 mb-2">TOR1 Included</h4>
                  <p className="text-gray-600 text-sm">We handle your customs paperwork</p>
                </CardContent>
              </div>

              <div className="text-center mt-8">
                <div className="flex justify-center">
                  <Button 
                    size="lg" 
                    className="bg-blue-900 hover:bg-blue-800 text-lg px-8 py-6"
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    Get Your Spain Removal Quote
                    <ExternalLink className="ml-2" size={20} />
                  </Button>
                </div>
                
                <p className="text-sm text-gray-500 mt-4">
                  Serving: Costa del Sol, Barcelona, Madrid, Valencia, Alicante, and all of Spain
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
